'use strict';

// @ngInject
module.exports = function () {

};
